import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageDetail } from '@bookinglab/govbook-ui';
import { NavLink } from '@bookinglab/govbook-ui/layout';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import { DatastoreService } from '../../services';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, GbHeaderComponent],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	showLoginButton = environment.showLoginButton;

	constructor(private datastoreService: DatastoreService) {}

	login() {
		window.open(environment.loginUrl, '_blank');
	}

	isAdmin() {
		return this.datastoreService.adminJourney;
	}
	imageDetail: ImageDetail = {
		alt: 'NorfolkCounty Council Logo',
		src: 'https://www.norfolk.gov.uk/image/104/Norfolk.gov.uk-Logo/logo.png?m=1697636895650',
	};

	navigation: NavLink[] = [
		{
			text: 'Step-by-step-guide',
			url: 'https://www.norfolk.gov.uk/article/42565/A-step-by-step-guide-to-getting-married-in-Norfolk',
		},
		{
			text: 'Ceremonies',
			url: 'https://www.norfolk.gov.uk/article/42566/Marriage-and-civil-partnership-ceremonies',
		},
		{
			text: 'Fees',
			url: 'https://www.norfolk.gov.uk/article/42568/Marriage-and-civil-partnership-fees',
		},
		{
			text: 'Approved venues from ceremonies',
			url: 'https://www.norfolk.gov.uk/article/42570/Approved-venues-for-ceremonies-in-Norfolk',
		},
		{
			text: 'Book the registrar',
			url: 'https://www.norfolk.gov.uk/article/42572/Book-the-registrar-for-your-marriage-or-civil-partnership-ceremony',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `https://scripts.rbwm.gov.uk/scripts/search/?zoom_query=${formatted}&zoom_cat=3&op=Search&form_build_id=form-0-k2tn7F1VvWBuiRKQlCfmuU8Hv0MAVpMwbYo_61O-A&form_id=bbd_zoom_search_form&_gl=1*o2fyfi*_ga*MTczODQ3Mzk1My4xNzY0NTk1NjY0*_ga_B1S76ZFQXK*czE3NjQ1OTU2NjMkbzEkZzEkdDE3NjQ1OTU2ODUkajM4JGwwJGgw`;
		window.location.href = url;
	}
}
